"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportEquipmentCost = reportEquipmentCost;
exports.reportEquipmentDistribute = reportEquipmentDistribute;
exports.reportEquipmentRecover = reportEquipmentRecover;
exports.reportEquipmentRestart = reportEquipmentRestart;
exports.reportEquipmentRoomNo = reportEquipmentRoomNo;
exports.reportEquipmentUnbind = reportEquipmentUnbind;
exports.reportEquipmentUpgrade = reportEquipmentUpgrade;
require("core-js/modules/es6.function.name");
var _adminOperationReport = require("@/utils/adminOperationReport");
/**
 * 【操作埋点】设备管理模块上报方法
 * 实施时间：2026-05-25
 * 说明：铺货/回收/解绑/房间号/升级/重启/成本等
 */

/**
 * 设备铺货/分配埋点上报
 * @param {Array} snList - 设备SN码列表
 * @param {Object} targetInfo - 目标信息（商户或代理）
 * @param {string} targetType - 目标类型 'shop' | 'agent'
 */
function reportEquipmentDistribute(snList, targetInfo) {
  var targetType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'shop';
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '设备铺货',
    content: "\u4E3A ".concat(snList.length, " \u53F0\u8BBE\u5907\u94FA\u8D27\uFF0C\u76EE\u6807").concat(targetType === 'shop' ? '商户' : '代理', "\uFF1A").concat(targetInfo.name, "(ID:").concat(targetInfo.id, ")"),
    operation_id: 'pc_equipment_distribute_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_equipment_distribute_1');
}

/**
 * 设备回收埋点上报
 * @param {Array} snList - 设备SN码列表
 * @param {string} agentName - 代理名称
 * @param {number} agentId - 代理ID
 */
function reportEquipmentRecover(snList, agentName, agentId) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '回收设备',
    content: "\u4ECE\u4EE3\u7406\u300C".concat(agentName, "\u300D(ID:").concat(agentId, ") \u56DE\u6536 ").concat(snList.length, " \u53F0\u8BBE\u5907"),
    operation_id: 'pc_equipment_recover_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_equipment_recover_1');
}

/**
 * 设备解绑埋点上报
 * @param {Object} deviceInfo - 设备信息
 */
function reportEquipmentUnbind(deviceInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '解绑设备',
    content: "\u89E3\u7ED1\u8BBE\u5907\u3010".concat(deviceInfo.goods_name, "\u3011\uFF0CSN\u7801\uFF1A").concat(deviceInfo.goods_sn, "\uFF0C\u539F\u5546\u6237\uFF1A").concat(deviceInfo.store_name),
    operation_id: 'pc_equipment_unbind_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_equipment_unbind_1');
}

/**
 * 设置设备房间号埋点上报
 * @param {string} goodsSn - 设备SN码
 * @param {string} roomNo - 房间号
 * @param {string} storeName - 商户名称
 */
function reportEquipmentRoomNo(goodsSn, roomNo, storeName) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '设置房间号',
    content: "\u4E3A\u8BBE\u5907 SN:".concat(goodsSn, " \u8BBE\u7F6E\u623F\u95F4\u53F7\u4E3A\u300C").concat(roomNo, "\u300D\uFF0C\u6240\u5C5E\u5546\u6237\uFF1A").concat(storeName),
    operation_id: 'pc_equipment_room_no_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_equipment_room_no_1');
}

/**
 * 设备升级埋点上报
 * @param {Object} upgradeInfo - 升级信息
 */
function reportEquipmentUpgrade(upgradeInfo) {
  var snInfo = upgradeInfo.goods_sn ? 'SN:' + upgradeInfo.goods_sn : upgradeInfo.updating_depend ? upgradeInfo.updating_depend.join(',') : '';
  var statusInfo = upgradeInfo.upgrade_status === 2 ? '开启升级' : '关闭升级';
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '设备升级',
    content: "\u5347\u7EA7\u8BBE\u5907".concat(snInfo, "\uFF0C\u72B6\u6001\uFF1A").concat(statusInfo),
    operation_id: 'pc_equipment_upgrade_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_equipment_upgrade_1');
}

/**
 * 重启设备埋点上报
 * @param {Object} deviceInfo - 设备信息
 * @param {string} action - 操作类型 'restart' | 'remote_restart'
 */
function reportEquipmentRestart(deviceInfo) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'restart';
  var actionText = action === 'remote_restart' ? '远程重启' : '重启';
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: "".concat(actionText, "\u8BBE\u5907"),
    content: "".concat(actionText, "\u8BBE\u5907\u3010").concat(deviceInfo.goods_name, "\u3011\uFF0CSN\u7801\uFF1A").concat(deviceInfo.goods_sn),
    operation_id: 'pc_equipment_restart_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_equipment_restart_1');
}

/**
 * 设置设备成本埋点上报
 * @param {string} goodsSn - 设备SN码
 * @param {number} costPrice - 成本价格
 */
function reportEquipmentCost(goodsSn, costPrice) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '设置设备成本',
    content: "\u8BBE\u7F6E\u8BBE\u5907 SN:".concat(goodsSn, " \u7684\u6210\u672C\u4EF7\u4E3A ").concat(costPrice, " \u5143"),
    operation_id: 'pc_equipment_cost_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_equipment_cost_1');
}